import React, {useRef, useState} from "react";
import {
    Card,
    CardContent,
    Grid,
    TextField,
    Box,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormControlLabel,
    Checkbox,
    Button,
    Link, CircularProgress
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import {defaultColors} from "../ColorSchema";
import SendScreen from "../Components/SendScreen";
import axios from "axios";

const countries = [
    {code: "AF", name: "Afghanistan"},
    {code: "AL", name: "Albania"},
    {code: "DZ", name: "Algeria"},
    {code: "AS", name: "American Samoa"},
    {code: "AD", name: "Andorra"},
    {code: "AO", name: "Angola"},
    {code: "AG", name: "Antigua and Barbuda"},
    {code: "AR", name: "Argentina"},
    {code: "AM", name: "Armenia"},
    {code: "AU", name: "Australia"},
    {code: "AT", name: "Austria"},
    {code: "AZ", name: "Azerbaijan"},
    {code: "BS", name: "Bahamas"},
    {code: "BH", name: "Bahrain"},
    {code: "BD", name: "Bangladesh"},
    {code: "BB", name: "Barbados"},
    {code: "BY", name: "Belarus"},
    {code: "BE", name: "Belgium"},
    {code: "BZ", name: "Belize"},
    {code: "BJ", name: "Benin"},
    {code: "BT", name: "Bhutan"},
    {code: "BO", name: "Bolivia"},
    {code: "BA", name: "Bosnia and Herzegovina"},
    {code: "BW", name: "Botswana"},
    {code: "BR", name: "Brazil"},
    {code: "BN", name: "Brunei"},
    {code: "BG", name: "Bulgaria"},
    {code: "BF", name: "Burkina Faso"},
    {code: "BI", name: "Burundi"},
    {code: "CV", name: "Cabo Verde"},
    {code: "KH", name: "Cambodia"},
    {code: "CM", name: "Cameroon"},
    {code: "CA", name: "Canada"},
    {code: "CF", name: "Central African Republic"},
    {code: "TD", name: "Chad"},
    {code: "CL", name: "Chile"},
    {code: "CN", name: "China"},
    {code: "CO", name: "Colombia"},
    {code: "KM", name: "Comoros"},
    {code: "CG", name: "Congo"},
    {code: "CR", name: "Costa Rica"},
    {code: "HR", name: "Croatia"},
    {code: "CU", name: "Cuba"},
    {code: "CY", name: "Cyprus"},
    {code: "CZ", name: "Czech Republic"},
    {code: "DK", name: "Denmark"},
    {code: "DJ", name: "Djibouti"},
    {code: "DM", name: "Dominica"},
    {code: "DO", name: "Dominican Republic"},
    {code: "EC", name: "Ecuador"},
    {code: "EG", name: "Egypt"},
    {code: "SV", name: "El Salvador"},
    {code: "GQ", name: "Equatorial Guinea"},
    {code: "ER", name: "Eritrea"},
    {code: "EE", name: "Estonia"},
    {code: "ET", name: "Ethiopia"},
    {code: "FJ", name: "Fiji"},
    {code: "FI", name: "Finland"},
    {code: "FR", name: "France"},
    {code: "GA", name: "Gabon"},
    {code: "GM", name: "Gambia"},
    {code: "GE", name: "Georgia"},
    {code: "DE", name: "Germany"},
    {code: "GH", name: "Ghana"},
    {code: "GR", name: "Greece"},
    {code: "GD", name: "Grenada"},
    {code: "GT", name: "Guatemala"},
    {code: "GN", name: "Guinea"},
    {code: "GW", name: "Guinea-Bissau"},
    {code: "GY", name: "Guyana"},
    {code: "HT", name: "Haiti"},
    {code: "HN", name: "Honduras"},
    {code: "HU", name: "Hungary"},
    {code: "IS", name: "Iceland"},
    {code: "IN", name: "India"},
    {code: "ID", name: "Indonesia"},
    {code: "IR", name: "Iran"},
    {code: "IQ", name: "Iraq"},
    {code: "IE", name: "Ireland"},
    {code: "IL", name: "Israel"},
    {code: "IT", name: "Italy"},
    {code: "CI", name: "Ivory Coast"},
    {code: "JM", name: "Jamaica"},
    {code: "JP", name: "Japan"},
    {code: "JO", name: "Jordan"},
    {code: "KZ", name: "Kazakhstan"},
    {code: "KE", name: "Kenya"},
    {code: "KI", name: "Kiribati"},
    {code: "KR", name: "Korea, South"},
    {code: "KW", name: "Kuwait"},
    {code: "KG", name: "Kyrgyzstan"},
    {code: "LA", name: "Laos"},
    {code: "LV", name: "Latvia"},
    {code: "LB", name: "Lebanon"},
    {code: "LS", name: "Lesotho"},
    {code: "LR", name: "Liberia"},
    {code: "LY", name: "Libya"},
    {code: "LI", name: "Liechtenstein"},
    {code: "LT", name: "Lithuania"},
    {code: "LU", name: "Luxembourg"},
    {code: "MG", name: "Madagascar"},
    {code: "MW", name: "Malawi"},
    {code: "MY", name: "Malaysia"},
    {code: "MV", name: "Maldives"},
    {code: "ML", name: "Mali"},
    {code: "MT", name: "Malta"},
    {code: "MH", name: "Marshall Islands"},
    {code: "MR", name: "Mauritania"},
    {code: "MU", name: "Mauritius"},
    {code: "MX", name: "Mexico"},
    {code: "MD", name: "Moldova"},
    {code: "MC", name: "Monaco"},
    {code: "MN", name: "Mongolia"},
    {code: "ME", name: "Montenegro"},
    {code: "MA", name: "Morocco"},
    {code: "MZ", name: "Mozambique"},
    {code: "MM", name: "Myanmar"},
    {code: "NA", name: "Namibia"},
    {code: "NR", name: "Nauru"},
    {code: "NP", name: "Nepal"},
    {code: "NL", name: "Netherlands"},
    {code: "NZ", name: "New Zealand"},
    {code: "NI", name: "Nicaragua"},
    {code: "NE", name: "Niger"},
    {code: "NG", name: "Nigeria"},
    {code: "MK", name: "North Macedonia"},
    {code: "NO", name: "Norway"},
    {code: "OM", name: "Oman"},
    {code: "PK", name: "Pakistan"},
    {code: "PW", name: "Palau"},
    {code: "PA", name: "Panama"},
    {code: "PG", name: "Papua New Guinea"},
    {code: "PY", name: "Paraguay"},
    {code: "PE", name: "Peru"},
    {code: "PH", name: "Philippines"},
    {code: "PL", name: "Poland"},
    {code: "PT", name: "Portugal"},
    {code: "QA", name: "Qatar"},
    {code: "RO", name: "Romania"},
    {code: "RU", name: "Russia"},
    {code: "RW", name: "Rwanda"},
    {code: "KN", name: "Saint Kitts and Nevis"},
    {code: "LC", name: "Saint Lucia"},
    {code: "VC", name: "Saint Vincent and the Grenadines"},
    {code: "WS", name: "Samoa"},
    {code: "SM", name: "San Marino"},
    {code: "ST", name: "Sao Tome and Principe"},
    {code: "SA", name: "Saudi Arabia"},
    {code: "SN", name: "Senegal"},
    {code: "RS", name: "Serbia"},
    {code: "SC", name: "Seychelles"},
    {code: "SL", name: "Sierra Leone"},
    {code: "SG", name: "Singapore"},
    {code: "SK", name: "Slovakia"},
    {code: "SI", name: "Slovenia"},
    {code: "SB", name: "Solomon Islands"},
    {code: "SO", name: "Somalia"},
    {code: "ZA", name: "South Africa"},
    {code: "SS", name: "South Sudan"},
    {code: "ES", name: "Spain"},
    {code: "LK", name: "Sri Lanka"},
    {code: "SD", name: "Sudan"},
    {code: "SR", name: "Suriname"},
    {code: "SE", name: "Sweden"},
    {code: "CH", name: "Switzerland"},
    {code: "SY", name: "Syria"},
    {code: "TW", name: "Taiwan"},
    {code: "TJ", name: "Tajikistan"},
    {code: "TZ", name: "Tanzania"},
    {code: "TH", name: "Thailand"},
    {code: "TG", name: "Togo"},
    {code: "TO", name: "Tonga"},
    {code: "TT", name: "Trinidad and Tobago"},
    {code: "TN", name: "Tunisia"},
    {code: "TR", name: "Turkey"},
    {code: "TM", name: "Turkmenistan"},
    {code: "TV", name: "Tuvalu"},
    {code: "UG", name: "Uganda"},
    {code: "UA", name: "Ukraine"},
    {code: "AE", name: "United Arab Emirates"},
    {code: "GB", name: "United Kingdom"},
    {code: "US", name: "United States"},
    {code: "UY", name: "Uruguay"},
    {code: "UZ", name: "Uzbekistan"},
    {code: "VU", name: "Vanuatu"},
    {code: "VE", name: "Venezuela"},
    {code: "VN", name: "Vietnam"},
    {code: "YE", name: "Yemen"},
    {code: "ZM", name: "Zambia"},
    {code: "ZW", name: "Zimbabwe"}
];

function checkEmpty(value) {
    return value.length === 0;
}

export default function CheckoutForm(props) {
    const {checked, choiceMap, data} = props;
    const [formSend, setFormSend] = useState(false)
    const [formHeight, setFormHeight] = useState(0)
    const [formWidth, setFormWidth] = useState(0)
    const formRef = useRef(null)
    const [loading, setLoading] = useState(false)
    const [formValues, setFormValues] = useState({
        firstName: "",
        lastName: "",
        email: "",
        gender: "",
        street: "",
        number: "",
        door: "",
        city: "",
        zip: "",
        country: "",
        notes: "",
        discount: "",
        agb: false,
        privacy: false,
    });

    const [formErrors, setFormErrors] = useState({
        firstName: false,
        lastName: false,
        email: false,
        gender: false,
        street: false,
        number: false,
        door: false,
        city: false,
        zip: false,
        country: false,
        notes: false,
        discount: false,
        agb: false,
        privacy: false,
    });

    const emailValidator = value => {
        if (!/^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/.test(value))
            return true;
        return false;
    };

    const handleChange = (e) => {
        const {name, value, validity} = e.target;
        setFormValues((prev) => ({...prev, [name]: value}));

        if (name === "email") {
            setFormErrors((prev) => ({...prev, [name]: emailValidator(value)}));
        }
    };

    const handleCheckbox = (e) => {
        const {name, checked} = e.target;
        setFormValues((prev) => ({...prev, [name]: checked}));
    };

    // calculate total
    const totalChecked = data
        .filter((item) => checked.includes(item.id))
        .reduce((sum, item) => {
            const idx = choiceMap[item.id] ?? 0;
            const cost = item.options ? item.options[idx].cost : item.price;
            return sum + cost;
        }, 0);

    const formattedTotal = totalChecked.toFixed(2).replace('.', ',') + '€';

    const handleSubmit = () => {
        // gather package selection details
        const packages = data
            .filter((item) => checked.includes(item.id))
            .map((item) => ({
                id: item.id,
                title: item.title,
                optionIndex: choiceMap[item.id] ?? null,
                cost: item.options ? item.options[choiceMap[item.id]].cost : item.price,
            }));
        let message = "Name: " + formValues.firstName + " " + formValues.lastName + "\n" +
            "Mail: " + formValues.email + "\n" +
            "Geschlecht: " + formValues.gender + "\n" +
            "Straße: " + formValues.street + "\n" +
            "Nr.: " + formValues.number + "\n" +
            "Stiege: " + formValues.door + "\n" +
            "Ort: " + formValues.city + "\n" +
            "PLZ: " + formValues.zip + "\n" +
            "Land: " + formValues.country + "\n" +
            "Anmerkung: " + formValues.notes + "\n" +
            "Rabattcode: " + formValues.discount + "\n" +
            "Total Cost: " + formattedTotal + "\n";

        packages.forEach((item) => {
            message += item.title + ": " + item.cost + ": " + item.optionIndex + "\n"
        })
        setLoading(true)
        axios.post('https://api.smart-physique.at/api/Email/send/chappa', {
            From: formValues.email.trim(),
            To: 'info@smart-physique.at',
            Subject: 'New Customer Shop Request',
            Body: message
        })
            .then(function (response) {
                setFormHeight(formRef.current.clientHeight)
                setFormWidth(formRef.current.clientWidth)
                setFormSend(true)
            })
            .catch(function (error) {
                setFormErrors((prev) => ({...prev, ["email"]: true}));
            }).finally(async function () {
            setLoading(false)
        });


    };
    let sendable =
        !checkEmpty(formValues.email) &&
        !checkEmpty(formValues.gender) &&
        !checkEmpty(formValues.street) &&
        !checkEmpty(formValues.number) &&
        !checkEmpty(formValues.city) &&
        !checkEmpty(formValues.zip) &&
        !checkEmpty(formValues.country) &&
        !formErrors.email &&
        formValues.agb &&
        formValues.privacy && !loading;
    return (
        <Card
            sx={{
                maxWidth: 580,
                mx: "auto",
                p: 0,
                borderRadius: 4,
                boxShadow: 0,
                backgroundColor: formSend ? defaultColors.primary : defaultColors.surface,
                height: formSend ? formHeight : "auto",
                width: formSend ? formWidth : "auto"
            }}
            ref={formRef}
        >
            {!formSend ?
                (
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    name="firstName"
                                    label="Vorname"
                                    variant="outlined"
                                    size="small"
                                    value={formValues.firstName}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    name="lastName"
                                    label="Nachname"
                                    variant="outlined"
                                    size="small"
                                    value={formValues.lastName}
                                    onChange={handleChange}

                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} sx={{mt: 1}}>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    type="email"
                                    name="email"
                                    label="E‑Mail"
                                    variant="outlined"
                                    size="small"
                                    value={formValues.email}
                                    onChange={handleChange}
                                    error={formErrors.email}

                                />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="gender-label">Geschlecht</InputLabel>
                                    <Select
                                        labelId="gender-label"
                                        label="Geschlecht"
                                        name="gender"
                                        value={formValues.gender}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value="male">Männlich</MenuItem>
                                        <MenuItem value="female">Weiblich</MenuItem>
                                        <MenuItem value="other">Divers</MenuItem>
                                        <MenuItem value="unknown">Möchte ich nicht angeben</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} sx={{mt: 1}}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    name="street"
                                    label="Straße"
                                    variant="outlined"
                                    size="small"
                                    value={formValues.street}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <TextField
                                    fullWidth
                                    name="number"
                                    label="Nr."
                                    variant="outlined"
                                    size="small"
                                    value={formValues.number}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <TextField
                                    fullWidth
                                    name="door"
                                    label="Stiege/Tür"
                                    variant="outlined"
                                    size="small"
                                    value={formValues.door}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} sx={{mt: 1}}>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    name="city"
                                    label="Ort"
                                    variant="outlined"
                                    size="small"
                                    value={formValues.city}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={6} sm={4}>
                                <TextField
                                    fullWidth
                                    name="zip"
                                    label="PLZ"
                                    variant="outlined"
                                    size="small"
                                    value={formValues.zip}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={6} sm={4}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="country-label">Land</InputLabel>
                                    <Select
                                        labelId="country-label"
                                        label="Land"
                                        name="country"
                                        value={formValues.country}
                                        onChange={handleChange}
                                    >
                                        {countries.map((country) => (
                                            <MenuItem key={country.code} value={country.code}>
                                                {country.name}
                                            </MenuItem>
                                        ))}
                                    </Select>

                                </FormControl>
                            </Grid>
                        </Grid>

                        <TextField
                            multiline
                            rows={4}
                            name="notes"
                            label="Optional: Anmerkungen"
                            variant="outlined"
                            fullWidth
                            size="small"
                            sx={{mt: 2}}
                            value={formValues.notes}
                            onChange={handleChange}
                        />

                        <TextField
                            fullWidth
                            name="discount"
                            label="Rabattcode"
                            variant="outlined"
                            size="small"
                            sx={{mt: 2}}
                            value={formValues.discount}
                            onChange={handleChange}
                        />

                        <Box sx={{mt: 3}}>
                            {data.map((value, index) =>
                                    checked.includes(value.id) && (
                                        <Box key={index} display="flex" justifyContent="space-between" fontSize="0.875rem">
                                            <span>{value.title}</span>
                                            <span>
                  {(choiceMap[value.id] !== undefined
                      ? value.options[choiceMap[value.id]].cost
                      : value.price)
                      .toFixed(2)
                      .replace('.', ',')}
                                                €
                </span>
                                        </Box>
                                    )
                            )}
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{pt: 1, mt: 1, borderTop: 1, borderColor: "divider"}}
                            >
                                <Typography variant="h6">Gesamtsumme</Typography>
                                <Typography variant="h6">{formattedTotal}</Typography>
                            </Box>
                        </Box>

                        <Box sx={{mt: 3}}>
                            <FormControlLabel
                                control={<Checkbox name="agb" checked={formValues.agb} onChange={handleCheckbox}/>}
                                label={<Typography variant="body2">
                                    <Link href="https://app.smart-physique.at/agb" target="_blank" underline="hover">
                                        AGB & Widerrufsrecht
                                    </Link>{" "}
                                    gelesen und akzeptiert.
                                </Typography>}
                            />
                            <FormControlLabel
                                control={<Checkbox name="privacy" checked={formValues.privacy}
                                                   onChange={handleCheckbox}/>}
                                label={<Typography variant="body2">
                                    <Link href="https://app.smart-physique.at/privacy-policy" target="_blank"
                                          underline="hover">

                                        Datenschutz</Link> gelesen und akzeptiert.
                                </Typography>}
                            />
                        </Box>

                        <Button
                            type="button"
                            variant="contained"
                            fullWidth
                            size="large"
                            startIcon={loading ? <CircularProgress size="25px" color="inherit"/> : <ShoppingCartIcon/>}
                            sx={{mt: 3, py: 1.5}}
                            onClick={handleSubmit}
                            disabled={!sendable}
                        >
                            {loading ? "Wird gesendet..." : "Kostenpflichtig bestellen"}
                        </Button>
                    </CardContent>
                ) : (
                    < CardContent
                        sx={{
                            height: "100%",
                            padding: "0"
                        }}
                    >
                        <SendScreen invert={false}/>
                    < /CardContent>
                )}
        </Card>
    );
}
